import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

function BrandIntro() {
  return (
    <section className="max-w-[1200px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="text-center mb-10">
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-100 mb-3">
          关于51影视
        </h1>
        <p className="text-sm text-foreground-500 max-w-2xl mx-auto leading-relaxed">
          致力于为广大影迷提供最新最全的免费影视资源，高清不卡顿，畅享追剧体验
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <h2 className="text-xl font-heading font-bold text-foreground-100 mb-4">品牌故事</h2>
          <div className="bg-background-100 rounded-xl border border-background-200/60 p-6">
            <div className="text-sm text-foreground-400 leading-relaxed space-y-4">
              <p>
                51影视成立于2020年，是一家专注于在线影视资源聚合与推荐的互联网平台。我们的使命是让每一位影迷都能轻松找到自己想看的影视内容，无需付费，无需等待，随时随地畅享高清观影体验。
              </p>
              <p>
                经过多年的发展，51影视已经积累了海量的影视资源库，涵盖<strong className="text-foreground-300">电视剧、电影、动漫、综艺</strong>等多个品类，覆盖中国大陆、港台、韩国、日本、欧美等地区的优质内容。
              </p>
              <p>
                我们的技术团队不断优化播放体验，采用先进的CDN加速技术，确保视频加载快速流畅，真正做到<strong className="text-foreground-300">不缓冲、不卡顿</strong>。同时，我们也在持续丰富内容库，每天更新最新热播剧集，让用户第一时间追到心仪的剧集。
              </p>
              <p>
                51影视始终坚持<strong className="text-foreground-300">免费、高清、无广告</strong>的服务理念，致力于打造华语地区最受欢迎的免费影视平台。我们相信，优质的影视内容应该被更多人看到，而不是被付费墙所阻隔。
              </p>
            </div>
          </div>
        </div>

        <div>
          <h2 className="text-xl font-heading font-bold text-foreground-100 mb-4">核心优势</h2>
          <div className="space-y-3">
            {[
              {
                icon: 'ri-movie-2-line',
                title: '海量资源',
                desc: '收录超过数万部影视作品，涵盖电视剧、电影、动漫、综艺等全品类内容，满足不同用户的多样化观影需求。',
              },
              {
                icon: 'ri-speed-up-line',
                title: '极速播放',
                desc: '采用先进的视频加速技术，支持多线路切换，确保高清流畅播放，真正做到不缓冲、不卡顿。',
              },
              {
                icon: 'ri-shield-check-line',
                title: '完全免费',
                desc: '所有内容完全免费，无需注册会员，无需付费订阅，打开网站即可畅享高清影视体验。',
              },
              {
                icon: 'ri-smartphone-line',
                title: '多端适配',
                desc: '完美支持电脑、平板、手机等多种设备，随时随地都能轻松追剧，不受设备限制。',
              },
              {
                icon: 'ri-refresh-line',
                title: '每日更新',
                desc: '紧跟各大平台的更新节奏，第一时间上线最新剧集，让用户不再错过任何精彩内容。',
              },
              {
                icon: 'ri-customer-service-2-line',
                title: '用心服务',
                desc: '7x24小时内容更新维护，持续优化用户体验，用心打造最好的免费影视平台。',
              },
            ].map((item) => (
              <div
                key={item.title}
                className="bg-background-100 rounded-xl border border-background-200/60 p-4 flex items-start gap-4"
              >
                <div className="w-10 h-10 rounded-lg bg-primary-500/10 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-lg text-primary-500`}></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-200 mb-1">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function Reputation() {
  const reviews = [
    {
      name: '追剧达人小王',
      rating: 5,
      content: '用了51影视两年了，资源真的很全，想看的剧基本都能找到。播放也很流畅，基本不用等缓冲。完全是免费的，太良心了！强烈推荐给所有喜欢追剧的朋友。',
      date: '2026-07-20',
    },
    {
      name: '影视爱好者老张',
      rating: 5,
      content: '作为一个看了十几年剧的老影迷，51影视是我目前用过最好的免费影视平台。资源更新速度快，画质清晰，而且真的不卡顿。网站的界面设计也很简洁，找剧很方便。',
      date: '2026-07-18',
    },
    {
      name: '学生党小李',
      rating: 4,
      content: '作为学生党，免费的观影平台真的太重要了。51影视的资源特别全，最新的热播剧都能第一时间看到，而且高清流畅。唯一的小建议是希望能增加弹幕功能，和网友一起讨论剧情会更有趣。',
      date: '2026-07-15',
    },
    {
      name: '家庭主妇刘女士',
      rating: 5,
      content: '平时在家带娃，看剧是我最大的消遣。51影视的综艺节目特别全，而且更新很快，完全不用等。最重要的是完全免费，不用考虑充会员的问题，用起来没有任何负担。',
      date: '2026-07-12',
    },
    {
      name: '上班族小陈',
      rating: 5,
      content: '通勤路上用手机追剧，51影视的移动端体验很好。视频加载快，画质清晰，而且支持断点续播，非常方便。每天上下班路上两集，一周就能追完一部剧。',
      date: '2026-07-10',
    },
    {
      name: '退休教师周阿姨',
      rating: 5,
      content: '女儿推荐我用51影视追剧，试了一下真的很不错。界面简单好操作，对于我们老年人来说也很友好。想看的老剧这里基本都有，画质也很清晰，非常满意。',
      date: '2026-07-08',
    },
  ];

  return (
    <section className="max-w-[1200px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-100 mb-3">
          用户口碑
        </h2>
        <p className="text-sm text-foreground-500 max-w-xl mx-auto">
          听听真实用户对51影视的评价，数百万用户的选择值得信赖
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {reviews.map((review) => (
          <div
            key={review.name}
            className="bg-background-100 rounded-xl border border-background-200/60 p-5"
          >
            <div className="flex items-center gap-1 mb-2">
              {Array.from({ length: 5 }, (_, i) => (
                <div key={i} className="w-4 h-4 flex items-center justify-center">
                  <i
                    className={`text-xs ${
                      i < review.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-600'
                    }`}
                  ></i>
                </div>
              ))}
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">{review.content}</p>
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium text-foreground-300">{review.name}</span>
              <span className="text-xs text-foreground-600">{review.date}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypotEl = form.querySelector<HTMLInputElement>('.website-alt-field input');
    if (honeypotEl?.value.trim()) {
      setFormStatus('success');
      form.reset();
      return;
    }
    setFormStatus('submitting');
    try {
      const formData = new FormData(form);
      const response = await fetch('https://readdy.ai/api/form/d9nkba0bdkpk99j7gl3g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await response.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch { parsed = null; }
      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        setFormStatus('error');
        setFormError(parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试');
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查连接后重试');
    }
  };

  return (
    <section className="max-w-[1200px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-100 mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 max-w-xl mx-auto">
          有任何问题或建议？欢迎通过以下方式与我们取得联系
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="space-y-4">
          {[
            {
              icon: 'ri-mail-line',
              title: '电子邮箱',
              desc: 'support@51yingshi.com',
              sub: '工作日24小时内回复',
            },
            {
              icon: 'ri-wechat-line',
              title: '微信公众号',
              desc: '51影视',
              sub: '关注获取最新影视资讯',
            },
            {
              icon: 'ri-question-answer-line',
              title: '意见反馈',
              desc: '我们非常重视您的意见',
              sub: '您的建议将帮助我们变得更好',
            },
          ].map((item) => (
            <div
              key={item.title}
              className="bg-background-100 rounded-xl border border-background-200/60 p-5 flex items-start gap-4"
            >
              <div className="w-11 h-11 rounded-lg bg-secondary-500/10 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-lg text-secondary-500`}></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-200 mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-300 font-medium">{item.desc}</p>
                <p className="text-xs text-foreground-500 mt-0.5">{item.sub}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-background-100 rounded-xl border border-background-200/60 p-6">
          <h3 className="text-lg font-heading font-bold text-foreground-100 mb-4">发送消息</h3>
          {formStatus === 'success' ? (
            <div className="text-center py-10">
              <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-primary-500/10 flex items-center justify-center">
                <i className="ri-check-line text-2xl text-primary-500"></i>
              </div>
              <p className="text-foreground-200 font-medium mb-1">消息已发送!</p>
              <p className="text-sm text-foreground-500">感谢您的反馈，我们会尽快回复</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} data-readdy-form="" className="space-y-4">
              <div className="website-alt-field">
                <input type="text" name="company_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <div>
                <label className="text-xs text-foreground-500 mb-1.5 block">您的姓名</label>
                <input
                  type="text"
                  name="name"
                  required
                  className="w-full h-10 px-4 rounded-lg bg-background-200/70 border border-background-300/60 text-sm text-foreground-200 placeholder-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors"
                  placeholder="请输入您的姓名"
                />
              </div>
              <div>
                <label className="text-xs text-foreground-500 mb-1.5 block">电子邮箱</label>
                <input
                  type="email"
                  name="email"
                  required
                  className="w-full h-10 px-4 rounded-lg bg-background-200/70 border border-background-300/60 text-sm text-foreground-200 placeholder-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors"
                  placeholder="请输入您的邮箱"
                />
              </div>
              <div>
                <label className="text-xs text-foreground-500 mb-1.5 block">消息内容</label>
                <textarea
                  name="message"
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-3 rounded-lg bg-background-200/70 border border-background-300/60 text-sm text-foreground-200 placeholder-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors resize-none"
                  placeholder="请输入您的消息（最多500字）"
                />
              </div>
              {formStatus === 'error' && (
                <p className="text-xs text-accent-400">{formError}</p>
              )}
              <button
                type="submit"
                disabled={formStatus === 'submitting'}
                className="w-full py-2.5 rounded-full bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50"
              >
                {formStatus === 'submitting' ? '发送中...' : '发送消息'}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-16">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-3">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>
        <BrandIntro />
        <Reputation />
        <ContactSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于51影视',
            description: '51影视致力于为广大影迷提供免费高清影视在线观看服务',
            mainEntity: {
              '@type': 'Organization',
              name: '51影视',
              url: 'https://www.51yingshi.com',
              description: '提供高清免费影视在线观看的平台',
              contactPoint: {
                '@type': 'ContactPoint',
                email: 'support@51yingshi.com',
                contactType: 'customer service',
              },
            },
          }),
        }}
      />
    </div>
  );
}